import angular from 'angular';

import tszCompanyActions from './tsz-company-actions/tsz-company-actions.module';
import tszCompanySettings from './tsz-company-settings/tsz-company-settings.module';
import tszCompanySubscriptions from './tsz-company-subscriptions/tsz-company-subscriptions.module';
import tszContact from './tsz-contact/tsz-contact.module';
import tszLoading from './tsz-loading/tsz-loading.module';
import tszNotificationBadge from './tsz-notification-badge/tsz-notification-badge.module';
import tszPriceCalculator from './tsz-price-calculator/tsz-price-calculator.module';
import tszPricing from './tsz-pricing/tsz-pricing.module';
import tszProgressBar from './tsz-progress-bar/tsz-progress-bar.module';
import tszReport from './tsz-report/tsz-report.module';
import tszReportActions from './tsz-report-actions/tsz-report-actions.module';
import tszReportMenuActions from './tsz-report-menu-actions/tsz-report-menu-actions.module';
import tszReportParam from './tsz-report-param/tsz-report-param.module';
import tszScrollTop from './tsz-scroll-top/tsz-scroll-top.module';
import tszToast from './tsz-toast/tsz-toast.module';
import tszTeam from './tsz-team/tsz-team.module';
import tszUserSettings from './tsz-user-settings/tsz-user-settings.module';
import tszImportCsv from './tsz-import-csv/tsz-import-csv.module';

const componentsModule = angular.module('meredicte.components', [
  tszCompanyActions.name,
  tszCompanySettings.name,
  tszCompanySubscriptions.name,
  tszContact.name,
  tszLoading.name,
  tszNotificationBadge.name,
  tszPriceCalculator.name,
  tszPricing.name,
  tszProgressBar.name,
  tszReport.name,
  tszReportActions.name,
  tszReportMenuActions.name,
  tszReportParam.name,
  tszScrollTop.name,
  tszToast.name,
  tszTeam.name,
  tszUserSettings.name,
  tszImportCsv.name,
]);

export default componentsModule;



// WEBPACK FOOTER //
// ./src/components/components.module.js